import { LinearProgress, Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { useHealthRecord } from "../../../store";
import { VaccinationActForm } from "../../components/VaccinationActForm";
import { useFetchHealthRecord } from "../../hooks/useFetchHealthRecord";
import { theme } from "../../layout/Theme";

export const EditVaccinationAct = () => {
  const { id: healthRecordId, vaccinationActId } = useParams() as {
    id: string;
    vaccinationActId: string;
  };
  const { isLoading: healthRecordIsLoading } = useFetchHealthRecord(healthRecordId);
  const healthRecord = useHealthRecord(healthRecordId);
  const vaccinationAct = healthRecord?.vaccinationActs.find((v) => v.id === vaccinationActId);

  return healthRecordIsLoading && !healthRecord ? (
    <LinearProgress variant="query" />
  ) : healthRecord && vaccinationAct ? (
    <Paper
      sx={{
        overflow: "hidden",
        border: `solid 1px ${theme.palette.neutral[200]}`,
        px: 4,
        py: 2,
      }}
      elevation={0}
    >
      <VaccinationActForm healthRecord={healthRecord} vaccinationAct={vaccinationAct} />
    </Paper>
  ) : null;
};
